import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CompanyClients } from 'src/app/shared/model/companyClients';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ExcelService {
  constructor() {}
  private apiUrlExport = `${environment.apiUrl}/export`;
  private http = inject(HttpClient);

  export(year?: number, clientId?: string) {
    let params = new HttpParams();
    if (year && year !== 0) {
      params = params.set('year', year.toString());
    }
    if (clientId && clientId !== '') {
      params = params.set('clientId', clientId);
    }
    return this.http.get(this.apiUrlExport, {
      params: params,
      responseType: 'blob',
      observe: 'response',
    });
  }
  getYears() {
    return this.http.get<number[]>(this.apiUrlExport + '/years');
  }

  getClients(): Observable<CompanyClients[]> {
    return this.http.get<CompanyClients[]>(
      `${environment.apiUrl}/company-client`,
    );
  }
}
